import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';

Swiper.use([EffectFade, Navigation, Pagination, Thumbs, Autoplay]);

const initSlider = (el, options) => {
  return new Swiper(el, {
    speed: 400,
    ...options,
  });
};

export default initSlider;
